<template>
  <section id="sustainability" class="position-relative">

    <b-container>
      <h5 class="text-white">Sustainability</h5>
      <h2 class="text-white">Living out our sustainability commitment</h2>

      <p class="text-white pb-4 hidden-xs show-lg">Our material topics</p>

      <b-row>
        <b-col cols="12" lg="4" class="position-relative">
          <scroll-view :offset="100">
            <template slot-scope="visibility">
              <c-color-box key="tablebox1"
                           :visible="visibility.tablebox1"
                           :text="'People'"
                           :cssClass="'people'"/>
              <c-text-box key="textbox1"
                          :visible="visibility.textbox1"
                          :delay="1500"
                          :key1="'1'"
                          :text1="'Human rights'"
                          :key2="'2'"
                          :text2="'Community engagement'"
                          :key3="'3'"
                          :text3="'Employee well-being'"/>
            </template>
          </scroll-view>
        </b-col>
        <b-col cols="12" lg="4">
          <scroll-view :offset="100">
            <template slot-scope="visibility">
              <c-color-box key="tablebox2"
                           :visible="visibility.tablebox2"
                           :delay="500"
                           :cssClass="'planet'"
                           :text="'Planet'"/>
              <c-text-box key="textbox2"
                          :visible="visibility.textbox2"
                          :delay="2000"
                          :key1="'4'"
                          :text1="'Supply chain'"
                          :key2="'5'"
                          :text2="'Energy, water and waste'"
                          :key3="'6'"
                          :text3="'Carbon dioxide'"/>
            </template>
          </scroll-view>
        </b-col>
        <b-col cols="12" lg="4">
          <scroll-view :offset="100">
            <template slot-scope="visibility">
              <c-color-box key="tablebox3"
                           :visible="visibility.tablebox3"
                           :delay="1000"
                           :text="'Prosperity'"
                           class="color-box"/>
              <c-text-box key="textbox3"
                          :visible="visibility.textbox3"
                          :delay="2500"
                          :key1="'7'"
                          :text1="'Profitability'"
                          :key2="'8'"
                          :text2="'Innovation'"
                          :key3="'9'"
                          :text3="'Business ethics'"/>
            </template>
          </scroll-view>
        </b-col>
      </b-row>
      <div class="btn-container">
        <a 	:href="$creo.browserPdfLink(pdfLinks.full, pdfLinks.sustainability, 28)"
	        	class="btn btn-black-trans"
		        target="_blank">
          Our sustainability work
        </a>
      </div>
    </b-container>
  </section>
</template>

<script>
import CColorBox from '../components/ColorBox.vue';
import CTextBox  from '../components/TextBox.vue';
import full from '../assets/pdf/full-report.pdf';
import sustainability from '../assets/pdf/sustainability.pdf';

  export default {
    name: 'Sustainability',
    data() {
      return {
        pdfLinks: {
          'full': full,
          'sustainability': sustainability
        }
      }
    },
    components: {
      CColorBox,
		  CTextBox
    }
  }
</script>



// WEBPACK FOOTER //
// src/sections/Sustainability.vue